module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggle2-off-355c089f.svg";